import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpHeaders, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { map, catchError, switchMap } from 'rxjs/operators';
import { ToastType } from '../classes/ToastType';
import { TranslatePipe } from './translate/translate.pipe';
import { Util } from '../services/util.service';
import { AuthorizationService } from '../services/authorization.service';
import { TranslationService } from '../services/translation.service';
import { ErrorDialog } from '../dialogs/error-dialog/error-dialog';
import { Config } from '../classes/Config';

@Injectable()
export class APIInterceptor implements HttpInterceptor {

  lastRequestTime: number;

  constructor(private util: Util,
    private translatePipe: TranslatePipe,
    private authorizationService: AuthorizationService,
    private translationService: TranslationService) {
    this.lastRequestTime = null;
  }

  inflightAuthRequest = null;

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      map((event: any) => {
        return event;
      }),
      catchError((error: HttpErrorResponse) => {
        let actualError = error.error;
        if (error.status === 401) {//if 401 Unauthorized
          this.util.createToast(this.translatePipe.getLabelOr(actualError?.error_description, "unauthorized"), ToastType.ERROR);
          this.authorizationService.logout();
          return throwError(error);
        }
        else if (error.status === 403) {
          this.util.createToast(this.translatePipe.getLabelOr(actualError?.error_description, "tokenExpired"), ToastType.ERROR);
          this.authorizationService.logout();
          return throwError(error);
        }
        else {
          return this.genericErrorHandler(error);
        }
      }));
  }

  errorHandler(error: any, actualError: any) {
    if (typeof (actualError) === "string") {
      actualError = JSON.parse(actualError);
    }
    let errorCode: string = "";
    if (actualError) {
      if (actualError.errorCode) {
        errorCode = actualError.errorCode;
      } else if (typeof actualError === "string") {
        errorCode = actualError;
      }
    }

    let toastType: ToastType = ToastType.ERROR;
    let label: string;
    if (this.translationService.getTranslations().hasOwnProperty(errorCode)) {
      label = this.translatePipe.getLabel(errorCode);
      switch (actualError.severity) {
        case "INFO":
          toastType = ToastType.INFO;
          break;
        case "WARNING":
          toastType = ToastType.WARNING;
          break;
        case "ERROR":
        case "ERRORFATAL":
          toastType = ToastType.ERROR;
          break;
      }
    } else {
      toastType = ToastType.ERROR;
      if (this.util.isStringEmpty(actualError.errorCode)) {
        label = this.translatePipe.getLabel("somethingWrong");
      } else {
        label = actualError.customMessage;
      }

    }
    //if has parameters
    if (actualError && actualError.parameters) {
      for (let index = 0; index < actualError.parameters.length; index++) {
        const param = actualError.parameters[index];
        label = label.replace("{" + index + "}", param);
      }
    }
    this.util.createToast(label, toastType, null, () => {
      if (actualError.stackTrace) {
        this.util.openDialog(ErrorDialog, { data: { error: actualError.stackTrace } });
      }
    });
    return throwError(error);
  }

  genericErrorHandler(error: any) {
    //handle if error is wrapped in a blob response type
    if (error?.error?.size && error.error?.size > 0 && error.error?.type && error.error?.type === "application/json") {
      var blob = new Blob([error.error], { type: "application/json" });
      let parsedError = JSON.parse(this.blobToString(blob));
      return this.errorHandler(error, parsedError);
    } else {
      return this.errorHandler(error, error.error);
    }
  }

  blobToString(b) {
    let uri = URL.createObjectURL(b);
    let xhr = new XMLHttpRequest();

    xhr.open('GET', uri, false);
    xhr.send();

    URL.revokeObjectURL(uri);
    return xhr.response;
  }
}
